export const ApiUrl = () => process.env.REACT_APP_IS_PROD == "yes" ? "" : "http://localhost";